import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import ProductItem from "./ProductItem";
import CartService from "services/Cart/";
import StorageService from 'services/StorageService/';
import AddressServices from "services/Address/";
import Loader from "components/Loader";
import ListService from "services/AccountLists/";
import TagManagerService from 'services/TagManager';
import CartActions from 'actions/Cart';
import SalesChannel from 'services/SalesChannel';
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let actions = [];
let skus = {};
let refresh = true;

const ModalLostProducts = () => {
    const [currentItems, setCurrentItems] = useState([]);
    const [oldSC, setOldSC] = useState('');
    const [oldNameSC, setOldNameSC] = useState('');
    const [oldMethod, setOldMethod] = useState('');
    const [oldAddress, setOldAddress] = useState('');
    const [itemsNotAvailables, setItemsNotAvailables] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.PRODUCTS_LOST_OPEN, _open));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
            skus = {}
        };
    }, []);

    const _open = (payload) => {

        if (payload && (payload !== {}) && payload.value) {
            let values = payload.value;

            setOldSC(values.oldSC);
            setCurrentItems(values.currentItems);
            setItemsNotAvailables(values.itemsNotAvailables ? values.itemsNotAvailables : []);
            setOldNameSC(values.oldNameSC);
            setOldMethod(values.oldMethod);
            setOldAddress(values.oldAddress);

            refresh = values.refresh;

            let prods = {};
            if (values.itemsNotAvailables && values.itemsNotAvailables.length) {
                values.itemsNotAvailables.map(item => {
                    prods[item.id] = { quantity: item.quantity };

                });
            }

            ListService.productsSkus(prods, false, true).then(response => {
                if (!response) return;
                skus = prods;
                setProducts(response);
            });
        }

    }

    const _close = () => {
        skus = {};
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.PRODUCTS_LOST_CLOSE),0);
    }

    const _removeMultiItems = (items) => {
        if(!(items && items.length)) return false;

        let itemsRemoved = items.map(item => {
            return {
                id: item.id,
                quantity: item.quantity
            }
        });
        return CartActions.removeMultiItems(itemsRemoved);
    }

    const _continue = () => {
        let productsItems = []; 
        const orderFormId = StorageService.getItem('orderFormId');
        setLoading(true);
        let itemsRemoved = {
            orderFormId: orderFormId,
            products: [],
            sc: oldSC,
            oldNameSC: oldNameSC,
            oldMethod: oldMethod,
            oldAddress: oldAddress
        }

        products.map((product,i) => {
            productsItems.push(product);
            const item = product.items ? product.items[0] : '';
            itemsRemoved.products.push({
                id: item.itemId,
                seller: item.sellers[0].sellerId,
                quantity: skus[item.itemId].quantity
            });

            if (i > 0 && ((i + 1) % 20) === 0) {
                TagManagerService.removeItemsModalChangeSalesChannel(productsItems, item ? skus[item.itemId].quantity : 1);
                productsItems = [];
            }
            if (i === (products.length - 1)) {
                TagManagerService.removeItemsModalChangeSalesChannel(productsItems, item ? skus[item.itemId].quantity : 1);
            }
        });

        _removeMultiItems(itemsNotAvailables).then(() => {
            StorageService.setItem('productsRemoved', JSON.stringify(itemsRemoved));

            if (refresh && window) {
                PubSub.dispatch(actionsType.SET_SALES_CHANNEL);
            } else {
                CartActions.getCart();
            }

            setLoading(false);
            _close();
        });

    }

    const cancel = (close = true) => {
        skus = {};
        let items = currentItems;
        items = items.concat(itemsNotAvailables ? itemsNotAvailables.map((item) => {
            return {
                id: item.id,
                quantity: item.quantity,
                seller: item.seller
            }
        }) : []);

        setLoading(true);

        SalesChannel.removeAll();

        SalesChannel.setMethodName(oldMethod);
        SalesChannel.setSalesChannelName(oldNameSC);
        SalesChannel.setSalesChannel(oldSC);

        if(oldMethod === 'seller-1-sla-DespachoaDomicilio') {
            AddressServices.applyAddress(oldAddress, [oldAddress], oldMethod).then(() => {
                CartService.updateOrderForm(items, oldSC).then((response) => {
                    if (refresh && response && window) {
                        PubSub.dispatch(actionsType.SET_SALES_CHANNEL);
                    } else {
                        CartActions.updateOrderForm(response);
                    }
                    setLoading(false);
                    if(close){
                        _close();
                    }
                    
                })
            })
        } else {
            CartService.updateOrderForm(items, oldSC).then(response => {
                if (refresh && response && window) {
                    window.location.reload();
                } else {
                    CartActions.updateOrderForm(response);
                }

                setLoading(false);
                if(close){
                    _close();
                }
                
            });
        }
    }

    return (
        <Modal customClass={'modal-products-lost'} actionOpen={actionsType.MODAL.PRODUCTS_LOST_OPEN} actionClose={actionsType.MODAL.PRODUCTS_LOST_CLOSE} callback={() => cancel(false)}>
            <div className='new-modal-container'>
                <div className="new-modal-scroll">
                    <div className={"wrap-products-not-availables"}>
                        {loading && <div className="wrap-products-not-availables-loader"><Loader/></div>}
                        <div className="new-modal-title">
                            <span className="modal-products-not-availables-text" ><span className="text-bold-not-available">Productos no disponibles</span></span>
                        </div>
                        <p className="modal-products-text">
                            Al cambiar de dirección o modo de entrega, los siguientes productos no estarán disponibles y <strong>serán eliminados de tu pedido.</strong>
                        </p>
                        {(products && products.length !== 0) && products.map((product, i) =>
                            <ProductItem key={i} product={product} />
                        )}
                    </div>
                </div>
    
                <div className="modal-actions">
                    <button className="secundary-btn modal-confirmation-not-quit-cart" onClick={cancel}>Cancelar</button>
                    <button className="primary-btn modal-confirmation-quit-cart" onClick={_continue}>Continuar</button>
                </div>
            </div>
        </Modal>
    )

}

export default ModalLostProducts;
